import React, { useEffect, useState } from "react";
import walletImg from "../../images/walletImg.png";
import star from "../../images/star.png";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import { useAlert } from "react-alert";
import { useSelector } from "react-redux";
import Web3 from "web3";
import { Connector, useConnect, useAccount } from "wagmi";
import { Modal } from "react-bootstrap";

export const ConnectPage = () => {
  const { address } = useAccount();
  const userStore = useSelector((state) => state.userReducer);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [pLoader, setPLoader] = useState(false);
  const alert = useAlert();
  const { connectors, connect } = useConnect();
  const [inputData, setInputData] = useState({});
  const [portfolioType, setPortfolioType] = useState("");

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  const AddWallet = async (wallet, pid) => {
    // e.preventDefault();
    setLoader(true);
    try {
      const payload = {
        userID: userStore?.users?.user?._id,
        wallet: wallet.toLowerCase(),
        portfolioID: pid,
      };
      const addResponse = await api.addWallet(payload);
      // console.log(addResponse);

      if (addResponse?.success) {
        alert.show("Wallet Added");
        navigate(`/portfolio/dashboard/${wallet}`);
        setLoader(false);
      } else {
        setLoader(false);
        alert.error(addResponse?.message || "Something went wrong");
      }
    } catch (e) {
      alert.show(e.message);
      // alert.show("Invalid Credentials or Account not verified");
      setLoader(false);
    }
  };

  const logingHandler = async () => {
    if (!window.ethereum) {
      // alert('Install ');
      alert.error("Install ");
    } else {
      let web3 = new Web3(window.ethereum);
      let accs = await window.ethereum.request({
        method: "eth_requestAccounts",
      });

      if (accs.length > 0) {
        let ad = accs[0].toLowerCase();
        // console.log(ad);
        setInputData({ ...inputData, wallet: ad });

        // AddWallet(ad);
      }
    }
    // setisConnecting(false)
  };
  const logingTrustWallet = async (connector) => {
    connect({ connector });
    if (address) {
      // AddWallet(address);
      setInputData({ ...inputData, wallet: address });
      handleShow();
    }
  };

  // useEffect(() => {
  //   if (address) {
  //     logingTrustWallet(address);
  //   }
  // }, [address]);

  const handleInput = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  const createPfManual = async () => {
    try {
      const payload = {
        ...inputData,
        type: portfolioType,
      };
      if (inputData?.wallet) {
        payload.wallet = inputData.wallet;
      }
      setPLoader(true);
      const addResponse = await api.portfolioInitiate(payload);
      // console.log(addResponse);
      if (addResponse?.success) {
        if (addResponse?.res?.type == "wallet") {
          // navigate(`/portfolio/dashboard/${addResponse?.res?._id || 1}`);
          AddWallet(inputData?.wallet, addResponse?.res?._id);
        } else {
          navigate(`/portfolio/tx/${addResponse?.res?._id}`);
        }
      }
      setPLoader(false);
    } catch (error) {
      console.log(error);

      alert.show(error?.message || "SOMETHING WENT WRONG");
      setPLoader(false);
    }
  };

  const handleSetWallet = () => {
    setPortfolioType("wallet");
    logingHandler();
    handleShow();
  };
  const handleOpenManual = () => {
    setPortfolioType("manual");
    handleShow();
  };

  return (
    <>
      <div className="ConnectPage">
        <div className="col1">
          <div className="goBack" onClick={() => navigate(-1)}>
            <i className="fa-solid fa-arrow-left"></i>
          </div>
          <div className="imgDiv">
            <img src={walletImg} alt="wallet" />
          </div>
        </div>
        <div className="col2">
          <img className="star1" src={star} alt="" />
          <img className="star2" src={star} alt="" />
          <div className="content">
            {/* <h3>Which wallet you want to connect</h3> */}
            <h3>Let’s get started with your first portfolio!</h3>
            <div className="tagline">
              Track profits, losses and valuation all in one place.
            </div>
            <div className="text-center mb-3">
              <div className="connentBtnM" onClick={() => handleSetWallet()}>
                <div className="icon">
                  <i className="fa-solid fa-wallet"></i>
                </div>
                <div>
                  <div className="title">Connect Your Wallet</div>
                  <div className="desc">
                    Simply connect your wallet and we'll sync it right away.
                  </div>
                </div>
              </div>
              <div className="connentBtnM" onClick={() => handleOpenManual()}>
                <div className="icon">
                  <i className="fa-solid fa-hand-pointer"></i>
                </div>
                <div>
                  <div className="title">Add Transactions Manually</div>
                  <div className="desc">
                    Enter all transaction details at your own pace to track your
                    portfolio.
                  </div>
                </div>
              </div>
              {/* <button className="connectBtn" onClick={() => logingHandler()}>
              Connect with meta mask
            </button>
            <h2 className="mt-1">OR</h2>
            <button
              className="connectBtn"
              onClick={() => navigate("/portfolio/tx")}
            >
              Add Transaction Manually
            </button> */}
            </div>
            {/* {connectors.map(
              (connector) =>
                connector.name == "Trust Wallet" && (
                  <div className="text-center mb-3">
                    <button
                      className="connectBtn"
                      key={connector.uid}
                      onClick={() => logingTrustWallet(connector)}
                    >
                      Connect with {connector.name}
                    </button>
                  </div>
                ),
            )} */}
            {/* <div className="text-center">
                    <button className="connectBtn">Connect with exchange</button>
                </div> */}
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body className="px-3 portfolio-modal" close>
          <h5
            className="bg-black mb-4 py-1"
            style={{ fontSize: "22px", fontWeight: 700 }}
          >
            Create Portfolio
          </h5>

          <div className="row g-3">
            <div className="col-12 mb-3">
              <label>Enter Name</label>
              <input
                type="text"
                className="form-control "
                value={inputData?.name}
                name="name"
                onChange={(e) => handleInput(e)}
                placeholder="Name..."
              />
            </div>
            {portfolioType == "wallet" && (
              <div className="col-12 mb-3">
                <label>Wallet Address</label>
                <input
                  type="text"
                  className="form-control "
                  value={inputData?.wallet}
                  name="wallet"
                  onChange={(e) => handleInput(e)}
                  placeholder="Wallet..."
                />
              </div>
            )}

            <div className="col-12">
              <button
                type="button"
                onClick={() => createPfManual()}
                className="themeBtn w-100 py-2"
                disabled={pLoader}
              >
                {pLoader && (
                  <i
                    className="fa fa-spinner fa-pulse mx-2 mb-1"
                    style={{ position: "relative", top: "-0px" }}
                  ></i>
                )}
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
